import React from 'react'
import ChatWithAllTempates from '../../components/Chat/ChatWithAllTemplates';

export const Dashboard = () => {
  return (
    <div>
      <ChatWithAllTempates />
    </div>
  );
}
